import { memo as u, useMemo as e } from "react";
import { MergeBuildings as p } from "../../utils/index22.js";
import { BuildingFC as s } from "../building-fc/index2.js";
import { StandardRenderLayers as c } from "../../utils/index27.js";
import { changeColorFuncUkV1V2 as d } from "../../colors/internal/index.js";
import { jsx as a } from "react/jsx-runtime";
const g = u(function({
  obj: i,
  emissive: r = "#000000",
  colourFunc: n = d,
  layers: o = c,
  ...m
}) {
  const f = e(() => p({
    parent: i
  }), [i]);
  return e(() => {
    for (const [, {
      material: t
    }] of o)
      "emissive" in t && t.emissive.set(r);
  }, [o, r]), /* @__PURE__ */ a(s, {
    building: f,
    colourFunc: n,
    layers: o,
    ...m
  });
}), S = g;
export {
  g as DetailedViewFC,
  S as SiteFC
};
//# sourceMappingURL=index.js.map
